// cleanup_convert_to_typescript_file_SECURITY_CONTACT

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Input } from '@glu/form-components';

import useStyles from 'components/securityContact/SecurityActivation.styles';
import { DEFAULT_PROPS } from 'constants.js';

const { EMPTY_FUNCTION } = DEFAULT_PROPS;

export const PhoneNumberComponent = ({
  format = undefined,
  id = 'phoneNumber',
  name = 'phoneNumber',
  onChange = EMPTY_FUNCTION,
  value = '',
  ...rest
}) => {
  const { groupInput } = useStyles();

  const formatPhoneNumber = (inputValue) => {
    const cleansedPhoneNumber = inputValue?.replace(/\D/gi, '') || '';
    const phoneNumberMatch = cleansedPhoneNumber?.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

    if (format) {
      const formattedPhone = cleansedPhoneNumber.length
        ? cleansedPhoneNumber?.replace(/(\d{0,3})(\d{0,3})(\d{0,4})/i, format)
        : '';
      return { formattedPhone, cleansedPhoneNumber };
    }
    const areaCode = phoneNumberMatch?.[1] ? `(${phoneNumberMatch[1]}` : '';
    const localNumber1 = phoneNumberMatch?.[2] ? `) ${phoneNumberMatch[2]}` : '';
    const localeNumber2 = phoneNumberMatch?.[3] ? `-${phoneNumberMatch[3]}` : '';

    const formattedPhone = areaCode + localNumber1 + localeNumber2;
    return { formattedPhone, cleansedPhoneNumber };
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    const { cleansedPhoneNumber, formattedPhone } = formatPhoneNumber(value);

    onChange({
      target: { name, value: formattedPhone },
      number: cleansedPhoneNumber,
      value: formattedPhone
    });
  };

  useEffect(() => {
    const { cleansedPhoneNumber, formattedPhone } = formatPhoneNumber(value);
    onChange({
      target: { name, value: formattedPhone },
      number: cleansedPhoneNumber,
      value: formattedPhone
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Input
      {...rest}
      className={groupInput}
      id={id}
      name={name}
      onChange={handleChange}
      type="text"
      value={value}
    />
  );
};

PhoneNumberComponent.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  format: PropTypes.string
};

export default PhoneNumberComponent;
